import { render, staticRenderFns } from "./WorkMode.vue?vue&type=template&id=07707fd7"
import script from "./WorkMode.vue?vue&type=script&lang=js"
export * from "./WorkMode.vue?vue&type=script&lang=js"
import style0 from "./WorkMode.vue?vue&type=style&index=0&id=07707fd7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports